// src/LoginScreen.js
import React, { useState } from 'react';
import { signIn } from '@aws-amplify/auth/cognito';
import styles from './ChatApp.module.css';

const LoginScreen = ({ onLogin, onNavigateToSignUp, onNavigateToLanding, onNavigateToConfirm }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        try {
            const { nextStep } = await signIn({ username, password });
            if (nextStep.signInStep === 'DONE') {
                onLogin({ username });
            } else {
                console.log('Unhandled sign-in step:', nextStep.signInStep);
                setError(`Unhandled sign-in step: ${nextStep.signInStep}`);
                setIsLoading(false);
            }
        } catch (err) {
            if (err.name === 'UserNotConfirmedException') {
                setError('User is not confirmed. Please check your email for a verification code.');
                onNavigateToConfirm(username); 
            } else {
                setError(err.message || 'Invalid username or password.');
            }
            setIsLoading(false);
        }
    };
    return (
        <div className={styles.loginContainer}>
            <form className={styles.loginBox} onSubmit={handleSubmit}>
                <div className={styles.loginLogo}>AirGrocer AI</div>
                <h2>Sales Login</h2>
                <input
                    type="text"
                    placeholder="Username (Email)"
                    className={styles.loginInput}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    disabled={isLoading}
                />
                <input
                    type="password"
                    placeholder="Password"
                    className={styles.loginInput}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={isLoading}
                />
                <button type="submit" className={styles.loginButton} disabled={isLoading}>
                    {isLoading ? 'Logging in...' : 'Login'}
                </button>
                {error && <div className={styles.loginError}>{error}</div>}
                <div className={styles.signUpLink}>
                    Need an account?{' '}
                    <button type="button" onClick={onNavigateToSignUp} className={styles.linkButton}>
                        Sign up
                    </button>
                </div>
                <div className={styles.signUpLink} style={{marginTop: '10px'}}>
                    Didn't get a code?{' '}
                    <button type="button" onClick={() => onNavigateToConfirm(username)} className={styles.linkButton}>
                        Confirm Account
                    </button>
                </div>
                <div className={styles.signUpLink} style={{marginTop: '10px'}}>
                    <button type="button" onClick={onNavigateToLanding} className={styles.linkButton}>
                        &larr; Back to Home
                    </button>
                </div>
            </form>
        </div>
    );
};
export default LoginScreen;